export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div
      class="${this.classes.classes}"
    >${this.getLine()} ${this.getContent()} ${this.getLine()}</div>`
  }

  getLine() {
    return `<div
      class="wf-flex-1 ${this.classes.contentClasses}"
      id="${this.ids.id}"
    />`;
  }

  getContent() {
    if (this.content.hasIcon) {
      return this.getIconContent()
    } else if (this.content.hasText) {
      return this.getTextContent()
    }
    return ``
  }

  getIconContent() {
    return `<div
      id="${this.ids.iconContainerId}"
      class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center ${this.classes.iconContainerClasses}"
    >
      <i
        id="${this.ids.iconId}"
        class="[elementIconClasses, content.class, content.icon]"
      />
    </div>`
  }

  getTextContent() {
    return `<div
      class="wf-flex-none wf-inset-y-0 focus:wf-outline-none"
      >${this.content.text}</div>`
  }
}
